<template lang="pug">
  svg.svg-sink(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 175 160" preserveAspectRatio="xMidYMid meet")
    title Sink
    path.sink-cls-1#faucet(d="M106.62,13.78h-.11A15.29,15.29,0,0,0,91.21.5H68.61A15.24,15.24,0,0,0,53.19,15.55V60.28H50.28v2.84H34.74V66H28.91V46H24.05V74.51H34.74v.95H50.28V85H61.94V60.28H59V18.4A13.32,13.32,0,0,1,72.49,5.24H88.17c5.69,0,11,3,12,8.54h-.31a1.9,1.9,0,1,0,0,3.8h6.8a1.9,1.9,0,1,0,0-3.8Z")
    rect.sink-cls-2(x="0.5" y="84.99" width="174" height="74.51" rx="6")
</template>

<script>
export default {
  name: 'svg-sink',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 175,
    },
    height: {
      type: Number,
      default: 160,
    },
  },

  data() {
    return {
      running: false,
    };
  },

};
</script>

<style lang="scss" scoped>
.svg-sink {

  .sink-cls-1 {
    fill: var(--fill-color-1, #b3b3b3);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
  }
  .sink-cls-2 {
    fill: var(--fill-color-2, #fff);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
  }

  #faucet:hover {
    stroke: #0071bc;
    stroke-width: 3px;
    stroke-opacity: 0.5;
  }
}
</style>
